import React, {Component} from 'react'
import {Accordion, Icon} from 'semantic-ui-react'
import {formatDate} from '../cads/format-date'

const colStyle = {textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap'}

// QB inventory adjustments - rows are [date, adjustment #, qty, memo], newest first
class InventoryAdjustmentAccordion extends Component {
  constructor(props) {
    super(props)
    this.state = {active: false}
  }

  toggleAccordion = () => this.setState({active: !this.state.active})

  render() {
    let {rows, expandAll} = this.props
    let {active} = this.state

    if (expandAll) {
      active = true
    }

    const net = rows.reduce((sum, row) => sum + Number(row[2]), 0)

    return (
      <Accordion>
        <Accordion.Title onClick={expandAll ? () => {} : this.toggleAccordion}>
          {
            rows.length > 0
            ?
            <Icon name='dropdown' style={active ? {rotate: '90deg'} : {}}/>
            :
            null
          }
          INVENTORY ADJUSTMENT ({net})
        </Accordion.Title>
        <Accordion.Content active={active && rows.length > 0}>
          {rows.map((row, index) =>
            <div key={index} style={{borderBottom: '1px solid rgb(212,212,212)', padding: '3px 0'}}>
              <span style={{marginRight: '8px'}}>{formatDate(row[0])}</span>
              <span style={{marginRight: '8px', color: row[2] < 0 ? '#db2828' : '#21ba45'}}>{row[2] > 0 ? '+' + row[2] : row[2]}</span>
              <span>#{row[1]}</span>
              {row[3] == null ? null : <div style={{...colStyle, fontWeight: 'normal'}} title={row[3]}>{row[3]}</div>}
            </div>
          )}
        </Accordion.Content>
      </Accordion>
    )
  }
}

export default InventoryAdjustmentAccordion
